const styles = ({ screenSizes, spacing }) => ({
  '&.btn-group-offers_qualified': {
    display: 'flex',
  },
  display: 'none',
  flexDirection: 'column',

  margin: [spacing.xl, 0, 0, 0],

  [`@media(max-width: ${screenSizes.mobileMax}px)`]: {
    display: 'flex',
    padding: [0, spacing.sm],
  },
});

export default styles;
